import { createContext } from "react";

export const AsiderContext: any = createContext<any>(null);